import { Header2 } from 'app/common/templates-next/page-template'
import ControlsBar from 'app/common/ui-next/controls-bar'
import PlainButton from 'app/common/ui-next/plain-button'


type Props = {
  title: string
  showFormControls?: boolean
  submitting?: boolean
  onClickCancel?: () => void
}

const HeaderWithSubmit = ({ title, showFormControls, submitting, onClickCancel }: Props) => {
  return (
    <ControlsBar spaceBetween top>
      <Header2 skipMargin>
        {title}
      </Header2>
      {showFormControls
        && <ControlsBar>
          <PlainButton
            onClick={onClickCancel}
            disabled={submitting}
            outline
          >
            {'Отмена'}
          </PlainButton>
          <PlainButton
            type="submit"
            disabled={submitting}
          >
            {submitting ? 'Сохранение...' : 'Сохранить'}
          </PlainButton>
        </ControlsBar>}
    </ControlsBar>
  )
}

export default HeaderWithSubmit
